


















































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { MetaDataTypes } from "@/data/enums/metaData";
import { DataModules } from "@/store/modules/data";

// Components
import MetaDataForm from "@/components/app/admin/metaData/metaDataForm.vue";

// Types
import { IInvoice } from "@/models/invoices";
import { IMetaData } from "@/models/metaData";

@Component({
  components: {
    "meta-data-provider": () =>
      import("@/components/app/admin/metaData/metaDataProvider.vue"),
    "meta-data-form": MetaDataForm
  }
})
export default class InvoiceMetaDataModal extends Vue {
  // Refs

  public declare $refs: {
    metaDataForm: MetaDataForm;
  };

  // Props

  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  // Data

  public metaDataType = MetaDataTypes.INVOICE;
  public metaDataForm: IMetaData = {};
  public hasErrors = false;
  public isProcessing = false;
  public formIsChanged = false;

  // Methods

  public onHasErrorsChange(value) {
    this.hasErrors = value;
  }

  public async save() {
    if (!this.canUpdate) return;

    try {
      this.isProcessing = true;

      await this.saveInvoiceMetaData();

      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public saveInvoiceMetaData() {
    return this.$store.dispatch(`data/${DataModules.INVOICES}/updateMetaData`, {
      id: this.invoiceId,
      data: { refresh_pdf: true, meta: this.metaDataForm }
    });
  }

  // Computed

  public get canUpdate() {
    return this.$userCan("create_update_invoice_meta_data");
  }
}
